import "core-js/modules/es.array.push.js";
import { defineComponent as _defineComponent } from 'vue';
import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createTextVNode as _createTextVNode, Transition as _Transition, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
const _hoisted_1 = {
  class: "wrap-body"
};
const _hoisted_2 = {
  class: "container"
};
import { ref, onMounted } from "vue";
import { tenantApi, loginApi } from "@/api/login";
import { showNotify } from "vant";
import store from "@/store";
import router from "@/router";
export default /*@__PURE__*/_defineComponent({
  __name: 'Login',
  setup(__props) {
    const loading = ref(false);
    const loginParam = ref({
      username: "",
      password: "",
      tenantId: undefined,
      device: "mobile",
      isVerification: false,
      captchaCode: "",
      captchaKey: "",
      tokenValue: ""
    });
    const tenantData = ref([]);
    onMounted(async () => {
      const res = await tenantApi();
      if (res.code == 200) {
        tenantData.value = res.data ?? [];
      } else {
        showNotify({
          type: 'danger',
          message: res.msg
        });
      }
    });
    const customFieldName = {
      text: 'label',
      value: 'value'
    };
    const login = async () => {
      try {
        loading.value = true;
        const res = await loginApi(loginParam.value);
        if (res.code == 200) {
          showNotify({
            type: 'success',
            message: '登录成功'
          });
          store.commit("SET_TOKEN", res.data?.tokenValue);
          router.push("/");
        } else {
          showNotify({
            type: 'danger',
            message: res.msg
          });
        }
      } finally {
        loading.value = false;
      }
    };
    const showPicker = ref(false);
    const tenantName = ref("");
    const onConfirm = ({
      selectedOptions
    }) => {
      showPicker.value = false;
      tenantName.value = selectedOptions[0].label;
      loginParam.value.tenantId = selectedOptions[0].value;
    };
    return (_ctx, _cache) => {
      const _component_van_field = _resolveComponent("van-field");
      const _component_van_picker = _resolveComponent("van-picker");
      const _component_van_popup = _resolveComponent("van-popup");
      const _component_van_button = _resolveComponent("van-button");
      const _component_van_form = _resolveComponent("van-form");
      return _openBlock(), _createElementBlock("div", _hoisted_1, [_cache[8] || (_cache[8] = _createElementVNode("div", {
        class: "title"
      }, [_createElementVNode("p", null, "你来啦！"), _createElementVNode("p", null, "口腔出库系统")], -1)), _createVNode(_Transition, {
        name: "van-fade"
      }, {
        default: _withCtx(() => [_createElementVNode("div", _hoisted_2, [_cache[7] || (_cache[7] = _createElementVNode("div", {
          class: "tit"
        }, "口腔出库系统", -1)), _createVNode(_component_van_form, {
          class: "form",
          onSubmit: login
        }, {
          default: _withCtx(() => [_createVNode(_component_van_field, {
            modelValue: tenantName.value,
            "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => tenantName.value = $event),
            "is-link": "",
            readonly: "",
            label: "口腔名称",
            placeholder: "选择口腔名称",
            onClick: _cache[1] || (_cache[1] = $event => showPicker.value = true),
            rules: [{
              required: true,
              message: '请选择口腔名称',
              trigger: 'onBlur'
            }]
          }, null, 8, ["modelValue"]), _createVNode(_component_van_popup, {
            show: showPicker.value,
            "onUpdate:show": _cache[3] || (_cache[3] = $event => showPicker.value = $event),
            "destroy-on-close": "",
            round: "",
            position: "bottom"
          }, {
            default: _withCtx(() => [_createVNode(_component_van_picker, {
              columns: tenantData.value,
              "columns-field-names": customFieldName,
              onCancel: _cache[2] || (_cache[2] = $event => showPicker.value = false),
              onConfirm: onConfirm
            }, null, 8, ["columns"])]),
            _: 1
          }, 8, ["show"]), _createVNode(_component_van_field, {
            modelValue: loginParam.value.username,
            "onUpdate:modelValue": _cache[4] || (_cache[4] = $event => loginParam.value.username = $event),
            label: "用户账号",
            placeholder: "请输入用户账号",
            rules: [{
              required: true,
              message: '请输入用户账号',
              trigger: 'onBlur'
            }]
          }, null, 8, ["modelValue"]), _createVNode(_component_van_field, {
            modelValue: loginParam.value.password,
            "onUpdate:modelValue": _cache[5] || (_cache[5] = $event => loginParam.value.password = $event),
            type: "password",
            label: "用户密码",
            placeholder: "请输入用户密码",
            rules: [{
              required: true,
              message: '请输入用户密码',
              trigger: 'onBlur'
            }]
          }, null, 8, ["modelValue"]), _createVNode(_component_van_button, {
            class: "btn",
            type: "primary",
            loading: loading.value,
            "native-type": "submit"
          }, {
            default: _withCtx(() => _cache[6] || (_cache[6] = [_createTextVNode("登录")])),
            _: 1,
            __: [6]
          }, 8, ["loading"])]),
          _: 1
        })])]),
        _: 1
      }), _cache[9] || (_cache[9] = _createElementVNode("div", {
        class: "square"
      }, [_createElementVNode("ul", null, [_createElementVNode("li"), _createElementVNode("li"), _createElementVNode("li"), _createElementVNode("li"), _createElementVNode("li")])], -1)), _cache[10] || (_cache[10] = _createElementVNode("div", {
        class: "circle"
      }, [_createElementVNode("ul", null, [_createElementVNode("li"), _createElementVNode("li"), _createElementVNode("li"), _createElementVNode("li"), _createElementVNode("li")])], -1))]);
    };
  }
});